import React from "react";

type PhoneIconProps = React.SVGProps<SVGSVGElement>;

export const PhoneIcon = ({
  width = 20,
  height = 20,
  ...props
}: PhoneIconProps) => (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M8.75 2H6.875C6.37772 2 5.90081 2.18061 5.54917 2.5021C5.19754 2.82359 5 3.25963 5 3.71429V16.2857C5 16.7404 5.19754 17.1764 5.54917 17.4979C5.90081 17.8194 6.37772 18 6.875 18H13.125C13.6223 18 14.0992 17.8194 14.4508 17.4979C14.8025 17.1764 15 16.7404 15 16.2857V3.71429C15 3.25963 14.8025 2.82359 14.4508 2.5021C14.0992 2.18061 13.6223 2 13.125 2H11.25M8.75 2V3.14286H11.25V2M8.75 2H11.25M8.75 16.2857H11.25" stroke="#253858" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


    
  
);

export default PhoneIcon;
